import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { ensureListing } from '../../util/data';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';

import css from './BookingBreakdown.module.css';

const LineItemBasePriceSummary = props => {
  const { transaction, unitType, intl, listing, isProvider } = props;
  const isNightly = unitType === LINE_ITEM_NIGHT;
  const isDaily = unitType === LINE_ITEM_DAY;
  const translationKey = isNightly
    ? 'BookingBreakdown.baseUnitNight'
    : isDaily
    ? 'BookingBreakdown.baseUnitDay'
    : 'BookingBreakdown.baseUnitQuantity';

  // Find correct line-item for given unitType prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/units', or 'line-item/time'
  // These are defined in '../../util/types';
  const unitPurchase = transaction.attributes.lineItems.find(
    item => item.code === unitType && !item.reversal
  );

  //Checking if custom Currency is set to Euro
  const currentListing = ensureListing(listing);
  const currencyCheck = (customCurrency, shareTribePrice) => {
    if(customCurrency!=undefined){
      if ((customCurrency).includes('Euro')){
        return (shareTribePrice.substr(1)+ "€");
      }else{
        return (shareTribePrice);
      }
    }else{
      return (shareTribePrice);
    }
  }
  const currencyCheck2 = (customCurrency, shareTribePrice) => {
    if(customCurrency!==undefined){
      if ((customCurrency).includes('Euro')){
        return (shareTribePrice + "€");
      }else{
        return ("$"+shareTribePrice);
      }
    }else{
      return ("$"+shareTribePrice);
    }
  }

  const quantity = unitPurchase ? unitPurchase.quantity.toString() : null;
  const total = unitPurchase ? '$'+((transaction.attributes.payinTotal.amount / 100).toFixed(2)).toString() : null;

  const toBePaid = ((transaction.attributes.payinTotal.amount / 100) * 0.15).toFixed(2);
  const onSite = ((transaction.attributes.payinTotal.amount / 100).toFixed(2)-toBePaid);

  //if the person is a customer we just need the total price
  if (isProvider){
      return quantity && total ? (
        <div>
          <div className={css.lineItem2}>
            <span className={css.itemLabel2}>
              <FormattedMessage id="BookingBreakdown.total" />
            </span>
            <span className={css.totalPrice2}>{currencyCheck(currentListing.attributes.publicData.customCurrency, total)}</span>
          </div>
        </div>

      ) : null;
  }

  //if the person is a provider we just need more information
  return quantity && total ? (
    <div>
      
      <div className={css.lineItem}>
          <span className={css.itemLabel}>
            <FormattedMessage id="BookingBreakdown.upfront" />
          </span>
          <span className={css.totalPrice}></span>
          <div className={css.totalPrice}>{currencyCheck2(currentListing.attributes.publicData.customCurrency, toBePaid)}</div>
          </div>
          <div>
          <span className={css.commissionLabel}>
            <FormattedMessage id="BookingBreakdown.upfrontText" />
          </span>
      </div> 
      <div className={css.lineItem}>
          <span className={css.itemLabel}>
            <FormattedMessage id="BookingBreakdown.onSite" />
          </span>
          <span className={css.totalPrice}></span>
          <div className={css.totalPrice}>{currencyCheck2(currentListing.attributes.publicData.customCurrency, onSite)}</div>
      </div>
      <hr className={css.totalDivider2} />
      <div className={css.lineItem2}>
        <span className={css.itemLabel2}>
          <FormattedMessage id="BookingBreakdown.total" />
        </span>
        <span className={css.totalPrice2}>{currencyCheck(currentListing.attributes.publicData.customCurrency, total)}</span>
      </div>
    </div>
   
    
  ) : null;
};

LineItemBasePriceSummary.propTypes = {
  transaction: propTypes.transaction.isRequired,
  unitType: propTypes.bookingUnitType.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemBasePriceSummary;
